import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './fonts/font.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

//registerServiceWorker();

//TODO
//load new page on social links
